import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { TeamReqDto } from '../_dtos/teamReqDto';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TeamResDto } from '../_dtos/teamResDto';
import { CloneTeamReqDto } from '../_dtos/cloneTeamReqDto';
import { SkipLoading } from '../_interceptors/loading.interceptor';
import { EditResourceReqDto } from '../_dtos/editResourceReqDto';
import { DeleteSiteOptionsDto } from '../_dtos/deleteSiteOptionsDto';

@Injectable({
  providedIn: 'root',
})
export class TeamsService {
  private createUri = environment.backendBaseUrl + '/teams';
  private cloneUri = environment.backendBaseUrl + '/teams/clone';
  private editUri = environment.backendBaseUrl + '/teams/';

  private readonly skipLoaderContext = new HttpContext();

  constructor(private http: HttpClient) {
    this.skipLoaderContext = new HttpContext().set(SkipLoading, true);
  }

  createTeam(teamData: TeamReqDto): Observable<TeamResDto> {
    return this.http.post<TeamResDto>(this.createUri, teamData, {
      context: this.skipLoaderContext,
    });
  }

  cloneTeam(teamData: CloneTeamReqDto): Observable<TeamResDto> {
    return this.http.post<TeamResDto>(this.cloneUri, teamData, {
      context: this.skipLoaderContext,
    });
  }

  updateTeams(
    id: string,
    editResourceData: EditResourceReqDto,
  ): Observable<void> {
    const uri = this.editUri + id;
    return this.http.patch<void>(uri, editResourceData);
  }

  deleteTeams(id: string, options?: DeleteSiteOptionsDto) {
    const uri = this.editUri + id;
    const defaultOptions: DeleteSiteOptionsDto = {
      isGroupConnected: false,
      siteId: '',
    };
    const requestOptions = options || defaultOptions;
    return this.http.delete<void>(uri, { body: requestOptions });
  }
}
